import { render } from "./FrequencyWatchHosForm.vue?vue&type=template&id=24d55b1c"
import script from "./FrequencyWatchHosForm.ts?vue&type=script&lang=js&external"
export * from "./FrequencyWatchHosForm.ts?vue&type=script&lang=js&external"

import "./FrequencyWatchHosForm.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__